<template>
    <div class="lock-designer-panel">
        <LockDesignerPanelHeader :backToRoute="backToRoute" @update-route-back="handleBackClick" />
        <div class="lock-designer-content">
            <div class="lock-designer-panel__content">
                <div class="lock-designer-panel__content-header">
                    <template v-for="(group, index) in componentGroups" :key="index">
                        <ComponentGroup v-if="group.isHeader" v-bind="group" @update-selection="handleUpdateSelection" @update-route="handleUpdateRoute" @update-route-back="handleBackClick"></ComponentGroup>
                    </template>
                </div>
                <div class="lock-designer-panel__content-body">
                    <template v-for="(group, index) in componentGroups" :key="index">
                        <ComponentGroup v-if="!group.isFooter && !group.isHeader"  v-bind="group" @update-selection="handleUpdateSelection" @update-route="handleUpdateRoute" @update-route-back="handleBackClick"></ComponentGroup>
                    </template>
                </div>
                <div class="lock-designer-panel__content-footer">
                    <template v-for="(group, index) in componentGroups" :key="index">
                        <ComponentGroup v-if="group.isFooter" v-bind="group" @update-selection="handleUpdateSelection" @update-route="handleUpdateRoute" @update-route-back="handleBackClick"></ComponentGroup>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentGroup from './ComponentGroup.vue'; // Adjust the import path based on your project structure
import LockDesignerPanelHeader from './LockDesignerPanelHeader.vue';
import { mapGetters, mapState } from 'vuex';
export default {
    name: 'LockDesignerPanel',
    components: {
        ComponentGroup,
        LockDesignerPanelHeader,
    },
    emits: ['update-route', 'update-selection', 'update-filters'],
    computed: {
        ...mapGetters(['backToRoute', 'componentGroups']),
        ...mapState(['selections']),
    },
    methods: {
        async handleUpdateSelection(selection) {
            await this.$emit('update-selection', selection);
        },
        handleUpdateRoute(route) {
            this.$emit('update-route', { route: route, direction: 'forward' });
        },
        handleBackClick(route) {
            this.$emit('update-route', { route: route, direction: 'back' });
        },
    },
};
</script>
